import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button, useUserService } from '@abroad/components'
import { gtmScheduleAllSessionAction } from '../quests/gtmfunctions'

const ConditionalScheduleGuidelineModal = ({
  show = false,
  handleClose = () => {},
  coachDetails,
  onScheduleAll = () => {},
}) => {
  const { user } = useUserService()
  const totalSessions = coachDetails?.totalSessions || 0
  const sowType = coachDetails?.sowType || coachDetails?.sow?.sowType
  const isQuestSow = sowType === 'QUEST'
  const isSingleSession = !isQuestSow && totalSessions === 1

  const getSessionLabel = () => {
    const coachName =
      coachDetails?.coach?.fullName || coachDetails?.coach?.fname
    const clientName =
      coachDetails?.client?.fullName || coachDetails?.client?.fname
    if (coachName || clientName) {
      return `Coaching Plan: ${coachName || '-'} & ${clientName || '-'}`
    }
    return 'Coaching Plan'
  }

  const handleScheduleAll = () => {
    gtmScheduleAllSessionAction(
      getSessionLabel(),
      user?._id,
      coachDetails?.questId,
      totalSessions || coachDetails?.remainingSessions,
    )
    onScheduleAll(coachDetails)
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size='lg'
      className='payment-modal'
      dialogClassName='payment-modal-dialog justify-content-center'>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h3 className='payment-modal-title mb-0 text-uppercase'>
          {isQuestSow ? 'Scheduling Your Sessions' : 'Scheduling Guideline'}
        </h3>
      </Modal.Header>
      <Modal.Body className='payment-modal-body'>
        <div className='s7 text-center'>
          {isQuestSow ? (
            <>
              Please select times for both your Preparation and Integration
              sessions now to reserve your Wisdom Guide&apos;s calendar.
              <br />
              Once confirmed, you can easily adjust or reschedule individual
              sessions whenever needed.
            </>
          ) : isSingleSession ? (
            <>
              There is 1 session included in your program. Please click the link
              below to schedule your session.
            </>
          ) : (
            <>
              There are {totalSessions} session
              {totalSessions !== 1 ? 's' : ''}. You need to book all of them at
              once. After booking, you can reschedule or cancel each session
              individually.
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-center gap-3 flex-row'>
        <Button
          variant='secondary-light'
          className='px-4 text-uppercase secondary-popup-button'
          size='sm'
          onClick={handleClose}>
          CANCEL
        </Button>
        <Button
          variant='saffron'
          className='px-4 text-uppercase'
          size='sm'
          onClick={handleScheduleAll}>
          {isQuestSow
            ? 'Schedule Sessions'
            : isSingleSession
            ? 'Schedule Session'
            : 'Schedule Multiple Sessions'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConditionalScheduleGuidelineModal
